import Associe from './associe.model';

export default class AssocieFormController {
    static $inject = ['$scope', '$state', '$stateParams', 'AssociesCommunicationService', 'AssociesService', 'notification', '$location'];

    constructor($scope, $state, $stateParams, AssociesCommunicationService, AssociesService, notification, $location) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.AssociesCommunicationService = AssociesCommunicationService;
        this.AssociesService = AssociesService;
        this.notification = notification;
        this.$location = $location;
    }

    async $onInit() {
        this.isEditMode = false;
        this.associe = {};
        this.loading = false;
        this.setAssocie(this.$stateParams.id);
        this.unregisterReinit = this.AssociesCommunicationService.registerReinit(() => this.initForm());
        this.initForm();
    }

    $onDestroy() {
        this.unregisterReinit();
    }

    initForm() {
        if (this.$stateParams && this.$stateParams.id) {
            this.isEditMode = true;
            const thatAssocie = {
                id: this.associe.id,
                libelle: this.associe.libelle
            };
        } else {
            this.isEditMode = false;
        }
    }

    async setAssocie(associeId) {
        if (associeId) {
            this.startLoading();
            try {
                this.isEditMode = true;
                const stillThatAssocie = await this.AssociesService.getAssocieById(associeId);
                this.associe = new Associe(stillThatAssocie);
            } catch (ex) {
                if (ex.status === 404) {
                    this.$state.go('associes.list', {}, { reload: true });
                }
                this.notification.error(ex.data);
            } finally {
                this.stopLoading();
            }
        } else {
            this.isEditMode = false;
            this.associe = new Associe();
        }
    }

    async checkCodeUnicity(code) {
        if (!code) {
            this.associe.codeExists = null;
            return;
        }
        this.startCodeLoading();
        try {
            if (code.match(/^[a-zA-Z0-9_]*$/)) {
                this.associe.codeExists = await this.AssociesService.codeExists(code);
            }
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopCodeLoading();
        }
    }

    // boutons de validation
    async sauvegarder() {
        if (this.checkValidity()) {
            this.startLoading();
            try {
                if (this.associe.id) {
                    const tmp = await this.updateAssocie();
                    this.notification.success('ASSOCIES.UPDATED');
                    return this.associe.id;
                }
                const tmp = await this.createAssocie();
                this.notification.success('ASSOCIES.CREATED');
                return tmp;
            } catch (ex) {
                this.notification.error(ex.data);
                return false;
            } finally {
                this.stopLoading();
            }
        } else {
            return false;
        }
    }

    async valider() {
        const returnedId = await this.sauvegarder();
        if (returnedId) {
            this.$state.go('associes.edit', { id: returnedId });
        }
    }
    async validerEtFermer() {
        const returnedId = this.sauvegarder();
        this.backToPreviousState();
    }

    annuler() {
        this.backToPreviousState();
    }

    backToPreviousState() {
        this.$state.go('associes.list');
    }

    async createAssocie() {
        this.startLoading();
        try {
            const returnedId = await this.AssociesService.createAssocie(this.associe);
            return returnedId;
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    async updateAssocie() {
        this.startLoading();
        try {
            const returnedId = await this.AssociesService.updateAssocie(this.associe);
            return returnedId;
        } catch (ex) {
            this.notification.error(ex.data);
            this.reinit();
        } finally {
            this.stopLoading();
        }
    }

    reinit() {
        this.setAssocie(this.$stateParams.id);
        this.AssociesCommunicationService.raiseReinit();
    }

    checkValidity() {
        this.$scope.$broadcast('associeValidations');
        return this.associe.isValid();
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    startCodeLoading() {
        this.codeLoading = true;
    }

    stopCodeLoading() {
        this.codeLoading = false;
    }
}
